export const getAutoPosition = (
  rect: DOMRect,
  popupWidth: number,
  gap = 10
) => {
  const spaceRight = window.innerWidth - rect.right;
  const openLeft = spaceRight < popupWidth;

  return {
    openLeft,
    top: rect.bottom + gap,
    left: openLeft ? rect.left - popupWidth + rect.width : rect.left,
    arrowLeft: openLeft ? popupWidth - 20 : 20,
  };
};
